import "./Home.module.css";
import MainSiteHeader from "@/reusable_sections/Header";
import AccelerateYourSmeGrowth from "./sections/AccelerateYourSmeGrowth";
import GlobalTrustNetwork from "./sections/GlobalTrustNetwork";
import CuratedResourceVerticals from "./sections/CuratedResourceVerticals";
import StepByStepOnboarding from "./sections/StepByStepOnboarding";
import MarketImpactStats from "./sections/MarketImpactStats";
import StartYourJourney from "./sections/StartYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainSiteHeader />
      <AccelerateYourSmeGrowth />
      <GlobalTrustNetwork />
      <CuratedResourceVerticals />
      <StepByStepOnboarding />
      <MarketImpactStats />
      <StartYourJourney />
      <Footer />
    </div>;
}